<template>
    <div
        v-if="!$wait.is('loading-page')"
        class="m-about"
    >
        <y-container>
            <y-row>
                <y-col>
                    <y-breadcrumb
                        :items="breadItems"
                        color="disabled"
                        divider="angle-left"
                    />
                </y-col>
            </y-row>
        </y-container>

        <y-page-head
            v-if="post.header_image"
            type="simple"
            :img="post.header_image"
        />

        <y-container>
            <y-row>
                <y-col>
                    <y-section-title
                        type="standard"
                        :title="contentTitle"
                        center
                    />
                    <y-page-content
                        v-if="post.text"
                        :content="post.text"
                        class="pb-15"
                    />
                </y-col>
            </y-row>

            <y-row v-if="awards && awards.length">
                <y-col>
                    <y-list-wrapper
                        type="one-line"
                        limit="5"
                        class="pb-15 justify-content-center"
                        :component="{
                            name: 'YInfoBox',
                            type: 'Simple',
                        }"
                        :items="awards"
                    />
                </y-col>
            </y-row>
        </y-container>
    </div>
</template>
<script>
    // Mixins
    import PageMixin from '@nodes/mixins/Page';

    // Components
    import {
        YRow, YCol, YContainer, YPageContent, YBreadcrumb,
    } from '@components/index';
    import { YSectionTitle, YPageHead, YListWrapper } from '@rogues/index';
    
    export default {
        name: 'AboutPage',

        components: {
            YSectionTitle,
            YPageHead,
            YListWrapper,
            YRow,
            YCol,
            YContainer,
            YPageContent,
            YBreadcrumb,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                pageTitle   : this.$t('about.title'),
                contentTitle: this.$t('about.content_title'),
                post        : null,
                awards      : [],
                breadItems  : [
                    {
                        title: this.$t('home.title'),
                        icon : 'house',
                        route: {
                            name: 'home',
                        },
                    },
                    {
                        title: this.$t('about.title'),
                        route: this.$router,
                    },
                ],
            };
        },

        methods: {
            /**
             * Fetch about page data
             * 
             * @returns {Promise}
             */
            fetch() {
                const hero = this.$services.Content.postSingle({
                    type     : 'page',
                    slug     : 'about-us',
                    including: ['title', 'text', 'header_image'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const awards = this.$services.Content.postList({
                    type     : 'awards',
                    locale   : this.$i18n.locale,
                    including: ['image:img', 'title'],
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([hero, awards]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.post = responses[0].data.results;
                    }
                    if (this.handleReq(responses, 1)) {
                        this.awards = responses[1].data.results;
                    }
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },

    };
</script>

<style lang="scss" src="../scss/about.scss"/>
